import React from 'react';
import { User, Eye, Crown, MessageSquare, Flame, Puzzle } from 'lucide-react';
export function ResultsSection() {
  const results = [{
    icon: <User className="w-[17px] h-[17px]" data-id="element-383" />,
    title: 'Dominas la psicología de la influencia',
    desc: 'Sin toxicidad ni manipulación dañina. Con claridad, ética e intención consciente.'
  }, {
    icon: <Eye className="w-[17px] h-[17px]" data-id="element-384" />,
    title: 'Lees a las personas con precisión',
    desc: 'Microexpresiones, lenguaje no verbal e incongruencias entre lo dicho y lo sentido.'
  }, {
    icon: <Crown className="w-[17px] h-[17px]" data-id="element-385" />,
    title: 'Te proteges de manipuladores',
    desc: 'Reconoces las tácticas antes de que surtan efecto y estableces límites claros.'
  }, {
    icon: <MessageSquare className="w-[17px] h-[17px]" data-id="element-386" />,
    title: 'Tu comunicación se vuelve magnética',
    desc: 'Persuades con historias, conectas más profundo y lideras con presencia real.'
  }, {
    icon: <Flame className="w-[17px] h-[17px]" data-id="element-387" />,
    title: 'Potencias tu liderazgo',
    desc: 'Ejerces influencia natural en tu entorno laboral, social y personal.'
  }, {
    icon: <Puzzle className="w-[17px] h-[17px]" data-id="element-388" />,
    title: 'Construyes relaciones genuinas',
    desc: 'Desde el conocimiento, no la ingenuidad. Con plena conciencia del juego social.'
  }];
  return <section className="py-14 md:py-20 bg-negro" data-id="element-389">
      <div className="container" data-id="element-390">
        <img src="https://cdn.magicpatterns.com/uploads/3HPyodzgfjnVY7Zk2eJvTQ/IA7.4.png" alt="Lo que nadie te dice — Código Oscuro" className="w-full max-w-[700px] mx-auto rounded-xl mb-10 md:mb-12 drop-shadow-[0_8px_32px_rgba(0,0,0,.5)]" data-id="element-391" />
        <div className="text-center max-w-[600px] mx-auto" data-id="element-392">
          <div className="section-label justify-center" data-id="element-393">
            Transformación real
          </div>
          <h2 className="font-playfair text-[clamp(1.7rem,3.5vw,2.7rem)] font-bold leading-[1.2] text-blanco text-center" data-id="element-394">
            Lo que cambia en ti
            <br data-id="element-395" />
            después de leer Código Oscuro
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-3.5 mt-8 md:mt-10 max-md:grid-cols-1" data-id="element-396">
          {results.map((r, i) => <div key={i} className="bg-negro-suave border border-[rgba(201,151,43,.1)] rounded-md p-[26px_22px] flex gap-4 items-start transition-all duration-300 hover:border-[rgba(201,151,43,.3)] hover:-translate-y-0.5" data-id="element-397">
              <div className="w-[44px] h-[44px] min-w-[44px] bg-[rgba(201,151,43,.1)] rounded-full flex items-center justify-center text-dorado-claro" data-id="element-398">
                {r.icon}
              </div>
              <div data-id="element-399">
                <h4 className="font-semibold text-blanco mb-1.5 text-[.93rem]" data-id="element-400">
                  {r.title}
                </h4>
                <p className="text-[.83rem] text-gris-texto leading-[1.6]" data-id="element-401">
                  {r.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}